import CountryFlag from "../CountryFlag/CountryFlag";

interface Props {
  agencyType: string;
  agencyCountryMap?: Record<string, string>;
  isTopMargin?: boolean;
}

const RegulatoryAgencyIcon = ({
  agencyType,
  agencyCountryMap,
  isTopMargin,
}: Props) => {
  const countryCode = agencyCountryMap?.[agencyType] || "empty";

  return (
    <CountryFlag
      isTopMargin={isTopMargin}
      countryCode={countryCode}
      style={{
        width: "auto",
        height: "1.7rem",
      }}
    />
  );
};

export default RegulatoryAgencyIcon;
